document.addEventListener('DOMContentLoaded', () => {
  const words = ['gratitude', 'clarity', 'audacity', 'greatness', 'joy'];

  const heroH1 = document.querySelector('.hero h1');
  if (!heroH1 || !heroH1.innerHTML.includes('gratitude')) return;

  // Split the h1 around "gratitude"
  const html = heroH1.innerHTML;
  const idx = html.indexOf('gratitude');
  const before = html.slice(0, idx);
  const after = html.slice(idx + 'gratitude'.length);

  heroH1.innerHTML = '';
  heroH1.insertAdjacentHTML('beforeend', before);

  const wrapper = document.createElement('span');
  wrapper.className = 'word-rotate';
  heroH1.appendChild(wrapper);

  heroH1.insertAdjacentHTML('beforeend', after);

  // Create word spans
  const spans = words.map((word, i) => {
    const span = document.createElement('span');
    span.className = 'word-rotate__word';
    if (i === 0) span.classList.add('word-rotate__word--active');
    span.textContent = word;
    wrapper.appendChild(span);
    return span;
  });

  // Measure widest/tallest word to set fixed container size
  let maxW = 0;
  let maxH = 0;
  spans.forEach((span) => {
    span.style.position = 'relative';
    span.style.opacity = '1';
    span.style.transform = 'none';
    const rect = span.getBoundingClientRect();
    maxW = Math.max(maxW, rect.width);
    maxH = Math.max(maxH, rect.height);
  });
  // Reset inline styles
  spans.forEach((span) => {
    span.style.position = '';
    span.style.opacity = '';
    span.style.transform = '';
  });

  wrapper.style.setProperty('--word-width', maxW + 'px');
  wrapper.style.setProperty('--word-height', maxH + 'px');

  let current = 0;
  let animating = false;

  setInterval(() => {
    if (animating) return;
    animating = true;

    const prev = current;
    current = (current + 1) % words.length;

    const outSpan = spans[prev];
    const inSpan = spans[current];

    // Start exit — keep --active until animationend so it stays visible
    outSpan.classList.add('word-rotate__word--exit');

    // Start enter
    inSpan.classList.add('word-rotate__word--enter');

    outSpan.addEventListener('animationend', () => {
      outSpan.classList.remove('word-rotate__word--active', 'word-rotate__word--exit');
      animating = false;
    }, { once: true });

    inSpan.addEventListener('animationend', () => {
      inSpan.classList.remove('word-rotate__word--enter');
      inSpan.classList.add('word-rotate__word--active');
    }, { once: true });
  }, 3000);
});
